import { render, staticRenderFns } from "./PertanyaanMobile.vue?vue&type=template&id=0e491da4&scoped=true"
import script from "./PertanyaanMobile.vue?vue&type=script&lang=js"
export * from "./PertanyaanMobile.vue?vue&type=script&lang=js"
import style0 from "./PertanyaanMobile.vue?vue&type=style&index=0&id=0e491da4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e491da4",
  null
  
)

export default component.exports